import { Outlet } from "react-router-dom";

export function RootLayout() {
  return (
    <div className="min-h-full bg-bg text-fg">
      <main className="mx-auto flex min-h-full max-w-2xl flex-col px-6 py-10">
        <Outlet />
      </main>
    </div>
  );
}
